export const DEFAULT_SERVER_ADDRESS = 'https://server.catalyst.chat/';
export const DEFAULT_THEMECOLOR = 'blue';
export const DEFAULT_AUTOFADE = 600;
